import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore from "swiper";
import { Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "./AmazonProductSlider.css";

SwiperCore.use([Pagination]);

// Individual Amazon Product Link Component
const AmazonProductLink = ({ imageUrl, linkUrl, productTitle }) => {
  return (
    <div className="amazon-product-link bg-white rounded p-4">
      <div className="product-image-wrap">
        <a href={linkUrl} target="_blank" rel="noopener noreferrer">
          <img src={imageUrl} alt="Product" className="product-image" />
        </a>
      </div>
      <p className="text-sm text-center">{productTitle}</p>
      <a href={linkUrl} target="_blank" rel="noopener noreferrer">
        <button className="product-button">View on Amazon</button>
      </a>
    </div>
  );
};

const AmazonProductSlider = () => {
  // Sample Amazon products data - you can modify this or make it a prop
  const amazonProducts = [
    {
      productTitle: "Pentel Brush Pen",
      imageUrl: "https://m.media-amazon.com/images/I/41be4n09wZL._AC_.jpg",
      linkUrl: "https://amzn.to/4caBLbY",
    },
    {
      productTitle: "Prismacolor Blue 20044 Col-Erase",
      imageUrl:
        "https://m.media-amazon.com/images/I/61HVZDkFxIL._AC_SL1500_.jpg",
      linkUrl: "https://amzn.to/4hV3P4A",
    },
    {
      productTitle: "Sketch Books",
      imageUrl:
        "https://m.media-amazon.com/images/I/51ecPytdmuL._AC_SL1500_.jpg",
      linkUrl: "https://amzn.to/3RsSHB4",
    },

    {
      productTitle: "Prismacolor Carmine Red 20045 Col-Erase",
      imageUrl:
        "https://m.media-amazon.com/images/I/61o90X-z04L._AC_SL1500_.jpg",
      linkUrl: "https://amzn.to/4cbP9wx",
    },
    {
      productTitle: "Gesture Drawing Books",
      imageUrl: "https://m.media-amazon.com/images/I/71fwJPejqgL._SL1500_.jpg",
      linkUrl: "https://amzn.to/4i2V6xk",
    },
    {
      productTitle: "Digital Drawing Tablets",
      imageUrl:
        "https://m.media-amazon.com/images/I/71Phsin+iDL._AC_SL1500_.jpg",
      linkUrl: "https://amzn.to/4jiwLES",
    },
    {
      productTitle: "Drawing Gloves",
      imageUrl:
        "https://m.media-amazon.com/images/I/613Yd40N1zL._AC_SL1000_.jpg",
      linkUrl: "https://amzn.to/4jeXYZ0",
    },
    {
      productTitle: "Kneadable Eraser",
      imageUrl:
        "https://m.media-amazon.com/images/I/61iF0r-7wcS._AC_SL1327_.jpg",
      linkUrl: "https://amzn.to/4jgTEbK",
    },
    {
      productTitle: "Art Tool Cases",
      imageUrl:
        "https://m.media-amazon.com/images/I/81YpyjEJcoL._AC_SL1500_.jpg",
      linkUrl: "https://amzn.to/3R1Vzop",
    },
    {
      productTitle: "Pencil Extender",
      imageUrl:
        "https://m.media-amazon.com/images/I/51mq0zmeLqL._AC_SL1500_.jpg",
      linkUrl: "https://amzn.to/4jixNkb",
    },
    {
      productTitle: "Pencil Sharpeners",
      imageUrl:
        "https://m.media-amazon.com/images/I/71kZUTtDp-L._AC_SL1500_.jpg",
      linkUrl: "https://amzn.to/4cyaPn3",
    },
    {
      productTitle: "Character Design Books",
      imageUrl: "https://m.media-amazon.com/images/I/71fJpUhIcyL._SL1500_.jpg",
      linkUrl: "https://amzn.to/4hUTpSs",
    },
  ];

  return (
    <div className="amazon-slider-container">
      <h3 className="amazon-slider-title">Need Art Supplies?</h3>
      <p className="text-center mb-4 ml-auto mr-auto max-w-[80%]">
        It helps support this project if you buy using these links.
      </p>
      <Swiper
        pagination={{ clickable: true }}
        spaceBetween={20}
        slidesPerView={1}
        breakpoints={{
          640: {
            slidesPerView: 1,
            spaceBetween: 10,
          },
          768: {
            slidesPerView: 3,
            spaceBetween: 15,
          },
          1024: {
            slidesPerView: 5,
            spaceBetween: 20,
          },
        }}
      >
        {amazonProducts.map((product, index) => (
          <SwiperSlide key={index}>
            <AmazonProductLink
              productTitle={product.productTitle}
              imageUrl={product.imageUrl}
              linkUrl={product.linkUrl}
            />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default AmazonProductSlider;
